// extracted by mini-css-extract-plugin
module.exports = {"card":"_4f720283bf--card--izuAK","checked":"_4f720283bf--checked--ldmLD","discount":"_4f720283bf--discount--mJ9tu"};